import type { FC } from 'react';
import c from 'classnames';
import { Trans, useTranslation } from 'react-i18next';
import UserSymbol from '@wix/da-shared-react/pkg/User/_partials/UserSymbol';
import { sanitizeHref, URLS } from '@wix/da-url';

import s from './DiscontinuedPlanDisclaimer.scss';

interface Props {
  className?: string;
}

const DiscontinuedPlanDisclaimer: FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  return (
    <Trans
      i18nKey="packagePicker.discontinuedPlanDisclaimer.message"
      components={{
        div: <div className={c(s['root'], className)} />,
        symbol: (
          <UserSymbol userSymbol="core_access" className={s['core-symbol']} />
        ),
        link1: (
          <a href={sanitizeHref(t('packagePicker.discontinuedPlanDisclaimer.kbUrl'))} />
        ),
        link2: <a href={URLS.ORDERS} />,
      }}
    />
  );
};
DiscontinuedPlanDisclaimer.displayName = 'DiscontinuedPlanDisclaimer';

export default DiscontinuedPlanDisclaimer;
